import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../../components/Shared/Header/Header';


export default function AppLayout() {
  return (
    <>
      <Header/>
      <main className="app-main">
        <Outlet />
      </main>
    </>
  );
}

